// src/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const memberId = sessionStorage.getItem("MemberID");

  if (!memberId  ) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
